<template>
	<div :class="this.$router.currentRoute.name">
		<div class="title-bar top-menu-toggler" data-responsive-toggle="top-menu" data-hide-for="large">
			<div class="grid-x align-center-middle">
				<div class="cell shrink menu-text">
					<router-link to="/"><img src="./assets/logo-aemporter-small.png"/></router-link>
				</div>
				<div class="cell auto text-right">
					<a data-toggle="top-menu"><i class="fas fa-bars fa-2x"></i></a>
				</div>
			</div>
		</div>
		
		<div class="grid-container">
			<div class="top-bar" id="top-menu">
				<div class="top-bar-left show-for-large">
					<ul class="vertical large-horizontal menu" data-responsive-menu="accordion large-dropdown">
						<li class="menu-text">
							<router-link to="/" v-on:click.native="menuClick()"><img
									src="./assets/logo-aemporter-small.png"/></router-link>
						</li>
					</ul>
				</div>
				<div class="text-left large-text-right sections">
					<ul class="vertical large-horizontal menu" data-responsive-menu="accordion large-dropdown">
						<li class="menu-text">
							<router-link to="/commercants" class="link" v-on:click.native="menuClick()"><i class="fas fa-utensils"></i> <span>Les</span>
								commerçants
							</router-link>
						</li>
						<li class="menu-text">
							<router-link to="/concept" class="link" v-on:click.native="menuClick()"><i class="far fa-lightbulb"></i> <span>Le</span>
								concept
							</router-link>
						</li>
					</ul>
				</div>
			</div>
			
			<router-view/>
		</div>
		<div class="bottom-bar">Aemporter.fr -
			<router-link to="/mentions" class="link">Mentions légales</router-link> - <a href="#" @click.prevent="disableTracking" alt="Cliquez ici pour désactiver le tracking de Google Analytics pour ce site"><small>Désactiver le tracking Google Analytics</small></a>
		</div>
	</div>
</template>

<style lang="scss">
	@import "~foundation-sites/scss/foundation.scss";
	
	$breakpoint-classes: (small medium large xlarge) !important;
	@import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:ital,wght@0,100;0,400;0,700;1,100;1,400;1,700&display=swap');
	* {
		font-family: 'IBM Plex Sans', sans-serif;
		line-height: 1.2;
	}
	
	$primary: #a23336;
	$secondary: #00759c;
	$grisclair: #cacaca;
	$grismoyen: #999999;
	$grisfonce: #333333;
	$mapHeightSmall: 250px;
	$mapHeightMedium: 300px;
	$mapHeightLarge: 350px;
	$infoHeightSmall: 150px;
	$infoHeightMedium: 200px;
	$infoHeightLarge: 200px;
	$infoWidth: 300px;
	$infoWidthMedium: 500px;
	$infoWidthLarge: 500px;
	$radius: 5px;
	body {
		margin-bottom: 40px !important;
		background:  url('/dot-grid.png')  !important;
	}
	
	h1 {
		text-transform: uppercase;
		font-weight: bolder !important;
		margin: 1rem 0 2rem !important;
		font-size: 1.5rem !important;
	}
	
	h2 {
		font-size: 1.4rem !important;
		font-weight: lighter;
		text-transform: uppercase;
	}
	
	h3 {
		font-size: 1.3rem !important;
		font-weight: lighter;
		text-transform: uppercase;
	}
	
	h4 {
		font-size: 1.25rem !important;
		font-weight: lighter;
		text-transform: uppercase;
	}
	
	hr {
		margin: 0.5rem 0;
	}
	
	a {
		color: $primary;
		font-weight: bold !important;
		&:hover {
			color: $secondary;
		}
	}
	
	.grid-container{
		@include breakpoint(large){
			max-width: 95rem !important;
		}
	}
	
	.button {
		background: $primary !important;
		text-transform: uppercase;
		font-weight: bold;
		border-radius: $radius !important;
		color: white !important;
		&:hover {
			cursor: pointer !important;
			background: darken($primary, 5) !important;
		}
	}
	
	/* VUE */
	.top-menu-toggler {
		padding: 5px;
		height: 60px;
		overflow: hidden;
		background: transparent !important;
		
		.grid-x {
			width: 100%;
		}
		
		a {
			color: $primary !important;
			&:hover {
				color: $primary !important;
			}
		}
	}
	
	#top-menu {
		padding: 5px 0;
		font-size: 80%;
		@include breakpoint(large) {
			height: 60px;
			overflow: hidden;
		}
		background: transparent !important;
		
		.menu {
			background: transparent !important;
		}
		
		.sections {
			width: 100%;
			@include breakpoint(large) {
				width: auto;
			}
			li{
				padding: 0 0 0.5rem 0;
			}
		}
		
		a {
			display: block;
			padding: 1rem !important;
			border: 1px solid rgba($primary, 0.25);
			border-radius: $radius;
			background: white;
			text-transform: uppercase;
			@include breakpoint(large) {
				padding: 0 !important;
				border: 0 !important;
				margin-right: 1rem;
			}
			color: $primary !important;
			
			span {
				color: $secondary !important;
			}
			
			&:hover {
				color: $primary !important;
				
				span {
					color: $secondary !important;
				}
			}
		}
	}
	
	.Home{
		@include breakpoint(large) {
		#top-menu{
			height: 30px;
			position:relative;
			top: 10px;
			.top-bar-left{
				display: none;
			}
			.sections{
				width: 100%;
				ul{
					justify-content: flex-end;
				}
			}
		}
		}
	}
	
	.bottom-bar {
		position: fixed;
		bottom: 0;
		width: 100%;
		text-align: center;
		padding: 10px;
		height: 40px;
		font-size: 12px;
		background: white;
		color: darken($secondary, 15);
		border-top: 1px dashed $light-gray;
		a {
			color: darken($secondary, 15);
			
			&:hover {
				color: darken($secondary, 15);
			}
		}
	}
	
	/* MAP */
	
	#map {
		width: 100%;
		height: $mapHeightSmall;
		border: 1px solid $grisclair;
		@include breakpoint(medium) {
			height: $mapHeightMedium;
		}
		@include breakpoint(large) {
			margin-top: 1rem;
			height: $mapHeightLarge;
		}
	}
	
	.gm-style-iw.gm-style-iw-c {
		width: $infoWidth !important;
		min-height: $infoHeightSmall !important;
		max-width: $infoWidth !important;
		@include breakpoint(medium) {
			width: $infoWidthMedium !important;
			max-width: $infoWidthMedium !important;
			min-height: $infoHeightMedium !important;
		}
		@include breakpoint(large) {
			width: $infoWidthLarge !important;
			max-width: $infoWidthLarge !important;
			min-height: $infoHeightLarge !important;
		}
	}
	
	.gm-style-iw-d {
		min-height: $infoHeightSmall !important;
		@include breakpoint(medium) {
			min-height: $infoHeightMedium !important;
		}
		@include breakpoint(large) {
			min-height: $infoHeightLarge !important;
		}
	}
	
	.info {
		height: $infoHeightSmall !important;
		text-transform: lowercase;
		padding-right:0.75rem;
		@include breakpoint(medium) {
			height: $infoHeightMedium !important;
		}
		@include breakpoint(large) {
			height: $infoHeightLarge !important;
		}
		
		.grid-x {
			height: $infoHeightSmall !important;
			@include breakpoint(medium) {
				height: $infoHeightMedium !important;
			}
			@include breakpoint(large) {
				height: $infoHeightLarge !important;
			}
		}
		
		.info-image {
			background-size: cover;
			background-position: center center;
			border-right: 5px solid $secondary;
		}
		
		.info-title {
			margin: 0.75rem 0;
			font-size: 1rem;
			font-weight: 700;
			text-transform: uppercase;
			@include breakpoint(medium) {
				font-size: 0.9rem;
			}
			color: $grisfonce;
		}
		
		.info-details {
			font-size: 0.75rem;
			font-weight: 700;
			color: $grismoyen;
			text-transform: capitalize;
			i{
				color: $secondary;
			}
			.info-lieu{
				text-transform: uppercase;
				color: $grisfonce;
			}
			.info-service{
				color: $secondary;
			}
		}
		
		.info-button {
			font-size: 0.75rem !important;
			@include breakpoint(medium) {
				font-size: 1rem;
			}
			white-space: nowrap;
			border-radius: $radius !important;
			border:2px solid $primary !important;
			background: white !important;
			color: $primary !important;
			width: 100% !important;
			margin: 0.75rem 0 !important;
			&:hover{
				border:2px solid white !important;
				background: $primary !important;
				color: white !important;
				box-shadow: 0 0 10px rgba($grismoyen, 0.45);
			}
		}
	}
	
	/* LIST */
	.map-list {
		padding: 1rem 0rem;
		height: calc(100vh - 60px - 250px - 40px - 40px - 60px);
		@include breakpoint(medium) {
			height: calc(100vh - 60px - 300px - 40px - 40px);
		}
		@include breakpoint(large) {
			min-height: 310px;
			height: calc(100vh - 350px - 60px - 1rem - 40px);
		}
		overflow-y: scroll;
	}
	.Home{
		.map-list{
			@include breakpoint(large) {
				height: calc(100vh - 350px - 30px - 1rem - 40px);
			}
		}
	}
	
	.textLight {
		font-weight: lighter;
		color: black;
		font-size: 0.75rem;
	}
	
	@media (min-width: 1200px) {
		.xlarge-shrink {
			width: 350px !important;
		}
	}
	
	.card {
		line-height: 1;
		border-radius: $radius !important;
		overflow: hidden;
		transition: all 0.2s ease-in-out;
		.card-image{
			border-bottom: 5px solid $secondary;
		}
		.card-section {
			padding: 0.5rem 0.75rem;
			display: block;
			text-transform: lowercase;
			.card-title {
				margin: 0;
				font-size: 1rem;
				font-weight: 700;
				text-transform: uppercase;
				color: $grisfonce;
				line-height: 0.9;
			}
			.card-details {
				font-size: 0.75rem;
				font-weight: 700;
				color: $grismoyen;
				text-transform: capitalize;
				i{
					color: $secondary;
				}
				.card-lieu{
					text-transform: uppercase;
					color: $grisfonce;
				}
				.card-service{
					color: $secondary;
				}
			}
		}
		.info-button{
			border:2px solid $primary !important;
			background: white !important;
			color: $primary !important;
			margin: 0 0.75rem 0.75rem 0.75rem !important;
			&:hover{
				border:2px solid white !important;
				background: $primary !important;
				color: white !important;
				box-shadow: 0 0 10px rgba($grismoyen, 0.45);
			}
		}
		&:hover{
			box-shadow: 0 0 20px rgba($grismoyen, 0.45);
		}
	}
	
	/* FILTERS */
	.filters-column {
		background: lighten($secondary, 66);
		position: relative;
		@include breakpoint(large) {
			border-radius: $radius;
			overflow: hidden;
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.25);
			position: relative;
		}
		
		.map-filters {
			padding-top: 1rem;
			border: 1px solid #cacaca;
			position: absolute;
			width: 100%;
			background: lighten($secondary, 66);
			min-height: $mapHeightSmall;
			@include breakpoint(medium){
				min-height: $mapHeightMedium;
			}
			@include breakpoint(large){
				border: 0;
				min-height: auto;
				position:static;
				width:auto;
			}
			label {
				line-height: 1.2;
				font-weight: bold;
				text-transform: uppercase;
				margin:0 0 0.5rem 0;
			}
			
			hr {
				margin-top: 0.25rem;
			}
			
			.geolocate-button {
				margin-left: 0.5rem;
				i{
					font-size: 1.5rem !important;
				}
			}
			
			.rayon {
				padding: 0 0.75rem 2rem;
			}
			
			.submit {
				margin-top: 1rem !important;
				background: $primary;
				border-radius: $radius !important;
				
				&:hover {
					background: $secondary;
				}
			}
			
			.reset {
				margin-top: 1rem !important;
				background: $dark-gray !important;
				border-radius: $radius !important;
				color: white !important;
				font-size: 80% !important;
				margin-right: 1rem !important;
				@include breakpoint(large) {
					display: block;
					margin: 1rem auto 0 !important;
				}
				
				&:hover {
					background: black;
				}
			}
		}
	}
	
	.filters-menu {
		box-shadow: none;
		max-height: 40px;
		overflow: hidden;
		border: 1px solid #cacaca;
		border-bottom: 0;
		background: lighten($secondary, 66) !important;
		color: $grisfonce !important;
		margin-bottom: 0;
		font-size: 0.8rem;
		width: 100%;
		.grid-x{
			width: 100%;
		}
		.menu-text {
			text-align: right;
			color: $grisfonce !important;
			line-height: 1.2;
			font-weight: bold;
			text-transform: uppercase;
			
			a {
				color: $grismoyen !important;
				
				&:hover {
					color: $grisfonce !important;
				}
			}
		}
	}
	
	/* component style */
	.vue-slider-disabled .vue-slider-process {
		background-color: #a7a7a7;
	}
	
	.vue-slider-disabled .vue-slider-dot-handle {
		border-color: #a7a7a7;
	}
	
	.vue-slider-disabled .vue-slider-mark-step-active {
		box-shadow: 0 0 0 2px #a7a7a7;
	}
	
	/* rail style */
	.vue-slider-rail {
		background-color: whitesmoke;
		border-radius: 15px;
		transition: background-color 0.3s;
	}
	
	.vue-slider:hover .vue-slider-rail {
		background-color: #e1e1e1;
	}
	
	/* process style */
	.vue-slider-process {
		background-color: $secondary;
		border-radius: 15px;
		transition: background-color 0.3s;
	}
	
	.vue-slider:hover .vue-slider-process {
		background-color: lighten($secondary, 8);
	}
	
	/* mark style */
	.vue-slider-mark-step {
		width: 100%;
		height: 100%;
		border-radius: 50%;
		box-shadow: 0 0 0 2px #e8e8e8;
		background-color: #fff;
	}
	
	.vue-slider-mark-step-active {
		box-shadow: 0 0 0 2px $secondary;
	}
	
	.vue-slider:hover .vue-slider-mark-step-active {
		box-shadow: 0 0 0 2px lighten($secondary, 8);
	}
	
	.vue-slider-mark-label {
		font-size: 12px;
		white-space: nowrap;
	}
	
	/* dot style */
	.vue-slider-dot-handle {
		cursor: pointer;
		width: 100%;
		height: 100%;
		border-radius: 50%;
		background-color: $primary;
		border: 2px solid white;
		box-sizing: border-box;
		transition: box-shadow 0.3s, border-color 0.3s;
	}
	
	.vue-slider:hover .vue-slider-dot-handle {
		border-color: white;
	}
	
	.vue-slider-dot-handle-focus {
		border-color: white;
		box-shadow: 0 0 0 5px rgba(54, 171, 255, 0.2);
	}
	
	.vue-slider:hover .vue-slider-dot-handle-focus {
		border-color: white;
	}
	
	.vue-slider-dot-handle:hover {
		border-color: white;
	}
	
	.vue-slider:hover .vue-slider-dot-handle:hover {
		border-color: white;
	}
	
	.vue-slider-dot-handle-disabled {
		cursor: not-allowed;
		border-color: #ddd !important;
	}
	
	.vue-slider-dot-tooltip {
		opacity: 0;
		visibility: hidden;
		transition: all 0.3s;
	}
	
	.vue-slider-dot-tooltip-inner {
		font-size: 14px;
		white-space: nowrap;
		padding: 6px 8px;
		color: #fff;
		border-radius: 5px;
		border-color: rgba(0, 0, 0, 0.75);
		background-color: rgba(0, 0, 0, 0.75);
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
		transform: scale(0.9);
		transition: transform 0.3s;
	}
	
	.vue-slider-dot-tooltip-inner::after {
		content: "";
		position: absolute;
	}
	
	.vue-slider-dot-tooltip-inner-top::after {
		top: 100%;
		left: 50%;
		transform: translate(-50%, 0);
		height: 0;
		width: 0;
		border-color: transparent;
		border-style: solid;
		border-width: 5px;
		border-top-color: inherit;
	}
	
	.vue-slider-dot-tooltip-inner-bottom::after {
		bottom: 100%;
		left: 50%;
		transform: translate(-50%, 0);
		height: 0;
		width: 0;
		border-color: transparent;
		border-style: solid;
		border-width: 5px;
		border-bottom-color: inherit;
	}
	
	.vue-slider-dot-tooltip-inner-left::after {
		left: 100%;
		top: 50%;
		transform: translate(0, -50%);
		height: 0;
		width: 0;
		border-color: transparent;
		border-style: solid;
		border-width: 5px;
		border-left-color: inherit;
	}
	
	.vue-slider-dot-tooltip-inner-right::after {
		right: 100%;
		top: 50%;
		transform: translate(0, -50%);
		height: 0;
		width: 0;
		border-color: transparent;
		border-style: solid;
		border-width: 5px;
		border-right-color: inherit;
	}
	
	.vue-slider-dot-tooltip-inner-top {
		transform-origin: 50% 100%;
	}
	
	.vue-slider-dot-tooltip-inner-bottom {
		transform-origin: 50% 0;
	}
	
	.vue-slider-dot-tooltip-inner-left {
		transform-origin: 100% 50%;
	}
	
	.vue-slider-dot-tooltip-inner-right {
		transform-origin: 0% 50%;
	}
	
	.vue-slider-dot:hover .vue-slider-dot-tooltip, .vue-slider-dot-tooltip-show {
		opacity: 1;
		visibility: visible;
	}
	
	.vue-slider-dot:hover .vue-slider-dot-tooltip .vue-slider-dot-tooltip-inner, .vue-slider-dot-tooltip-show .vue-slider-dot-tooltip-inner {
		transform: scale(1);
	}
	
	.theme-aemporter {
		& .vdatetime-popup__header,
		& .vdatetime-calendar__month__day--selected > span > span,
		& .vdatetime-calendar__month__day--selected:hover > span > span {
			background: $secondary;
		}
		
		& .vdatetime-year-picker__item--selected,
		& .vdatetime-time-picker__item--selected,
		& .vdatetime-popup__actions__button {
			color: $primary;
		}
	}
	
	.getcommercant-input {
		border: 1px solid $grisclair;
		border-radius: 0;
		width: 100%;
		padding: 0.5rem;
		box-sizing: border-box;
		position: relative;
		font-size: 1rem;
		line-height: 1.25;
		flex: 1;
		background-color: white;
	}
	
	.getcommercant-input:focus, .getcommercant-input[aria-expanded=true] {
		background-color: #fff;
		outline: none;
	}
	
	[data-position=below] .getcommercant-input[aria-expanded=true] {
		border-bottom-color: transparent;
		border-radius: 0
	}
	
	[data-position=above] .getcommercant-input[aria-expanded=true] {
		border-top-color: transparent;
		border-radius: 0;
		z-index: 2
	}
	
	.getcommercant[data-loading=true]:after {
		content: "";
		border: 3px solid rgba(0, 0, 0, .12);
		border-right-color: rgba(0, 0, 0, .48);
		border-radius: 100%;
		width: 20px;
		height: 20px;
		position: absolute;
		right: 12px;
		top: 50%;
		transform: translateY(-50%);
		animation: rotate 1s linear infinite
	}
	
	.getcommercant-result-list {
		margin: 0;
		border: 1px solid rgba(0, 0, 0, .12);
		padding: 0;
		box-sizing: border-box;
		max-height: 296px;
		overflow-y: auto;
		background: #fff;
		list-style: none;
	}
	
	[data-position=below] .getcommercant-result-list {
		margin-top: -1px;
		border-top-color: transparent;
		border-radius: 0;
		padding-bottom: 0
	}
	
	[data-position=above] .getcommercant-result-list {
		margin-bottom: -1px;
		border-bottom-color: transparent;
		border-radius: 0;
		padding-top: 0
	}
	
	.getcommercant-result {
		cursor: default;
		padding: 0.5rem;
	}
	
	.getcommercant-result:hover, .getcommercant-result[aria-selected=true] {
		background-color: rgba(0, 0, 0, .06)
	}
	
	@keyframes rotate {
		0% {
			transform: translateY(-50%) rotate(0deg)
		}
		to {
			transform: translateY(-50%) rotate(359deg)
		}
	}
	
	/* PAGES */
	.commercant-emplacements {
		margin-bottom: 2rem;
	}
</style>
<script>
    export default {
        name: "app",
        methods: {
            menuClick: function () {
                event.preventDefault();
                const breakpoint = document.querySelector('.top-menu-toggler').style.display;
                if (breakpoint !== 'none') {
                    document.querySelector('#top-menu').style.display = 'none';
                }
            },
            disableTracking: function() {
                this.$ga.disable();
                alert('Tracking désactivé');
            }
        }
    };
</script>
